module.exports = __webpack_public_path__ + "img/s2.5a39e5c3.png";